import NextCone from "../components/next-cone/prototype";
import CdnComponent from "../components/cdn-component/prototype";
import Iframe from "../components/iframe/prototype";
export default [NextCone, CdnComponent, Iframe];